const limitChar = (char: string | null | undefined, count: number = 10) => {
  const text = char ?? "";
  return text.slice(0, count) + (text.length > count ? "..." : "");
};

export default limitChar;